/* Built In Imports */
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Image } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LandingPageTopBanner from '@eternal/Components/Banner/LandingPageTopBanner';
import SimpleButton from '@eternal/Components/Buttons/SimpleButton';
import SectionTitle from '@eternal/Components/Headings/SectionTitle'; //eternal
import ContentArea from '@eternal/Components/Layout/ContentArea';
import MidContainer from '@eternal/Components/Layout/MidContainer';

/* Services */

/**
 * Renders the Section UI Component
 *
 * @param {object} sectionContent - Content from API
 * @param {string} language - Language of page
 * @param {string} region - Region of Page
 * @param {boolean} isLeftMenu - Left Navbar
 * @param {string} pType
 * @param {string} pageName
 * @returns {ReactElement} UpcomingDates component
 */

const SectionUI = ({
  sectionContent,
  region,
  language,
  section,
  isLeftMenu,
  pType,
  pageName,
  csrData,
  pageBody,
  FYDdate,
  pageConfig,
  disableButton,
}) => {
  // console.log("Section content", sectionContent);

  const router = useRouter();
  return (
    <Box w="100%" display="flex" flexDirection="column">
      {RenderComponents({
        sectionContent,
        region,
        language,
        section,
        isLeftMenu,
        pType,
        pageName,
        csrData,
        router,
        pageBody,
        FYDdate,
        pageConfig,
        disableButton,
      })}
    </Box>
  );
};

// async function loadModuleDynamically(moduleName) {
//   const SamskritiBanner = await import('@landing_pages/project-samskriti/SamskritiBanner');
//   return SamskritiBanner;
//   return (
//     <SamskritiBanner
//       sectionContent={sectionContent}
//       region={region}
//       lang={language}
//     />
//   );
// }

const RenderComponents = ({
  sectionContent,
  region,
  language,
  section,
  isLeftMenu,
  pType,
  pageName,
  csrData,
  router,
  pageBody,
  FYDdate,
  pageConfig,
  disableButton,
}) => {
  switch (sectionContent._modelApiKey) {
    case 'structured_text':
      return (
        <RenderStructuredText
          sectionContent={sectionContent}
          region={region}
          lang={language}
        />
      );
    case 'section_title':
      // const SectionTitle = dynamic(() => import('@components/Headings/SectionTitle'));
      return <SectionTitle titleObj={sectionContent} pageName={pageName} />;
    case 'landing_page_top_banner':
      return <LandingPageTopBanner sectionContent={sectionContent} />;
    case 'simple_button':
      return (
        <RenderSimpleButton
          sectionContent={sectionContent}
          section={section}
          region={region}
          lang={language}
          styleName={pageName}
          pageConfig={pageConfig}
          disableButton={disableButton}
          csrData={csrData}
        />
      );
    case 'gallery':
      return (
        <RenderGallery
          testimonialsObj={sectionContent}
          region={region}
          lang={language}
          section={section}
        />
      );

    case 'generic_iframe':
      const GenericFrame = dynamic(() =>
        import('@components/Embeds/GenericFrame')
      );
      return <GenericFrame sectionContent={sectionContent} section={section} />;
  }
};

const RenderSimpleButton = ({
  sectionContent,
  section,
  region,
  lang,
  // disableButton
  pageName,
  pageConfig,
  csrData,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  useEffect(() => {
    if (!csrData?.length > 0) {
      setDisableButton(true);
    }
  }, [csrData]);

  // const SimpleButton = dynamic(() => import('@components/Buttons/SimpleButton'));

  return (
    <SimpleButton
      style={sectionContent}
      region={region}
      lang={lang}
      disableButton={disableButton}
      pageConfig={pageConfig}
    />
  );
};

const RenderStructuredText = ({ sectionContent, region, lang, position }) => {
  return (
    <MidContainer>
      <Box className="event-text">
        <ContentArea
          mainContent={sectionContent.body}
          tAlign={sectionContent.style}
          region={region}
          lang={lang}
          sectionContent={sectionContent}
          position={position}
        />
      </Box>
    </MidContainer>
  );
};

const RenderGallery = ({ sectionContent, region, lang, section }) => {
  return (
    <Box display="flex" marginTop="80px">
      <Image loading="lazy" Gallery sectionContent={sectionContent} />
    </Box>
  );
};

export default SectionUI;
